var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6854_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.15038 4.29514L9.15061 4.29431L14.1888 7.33015L17.191 6.05923C17.8011 5.79392 18.4589 5.65788 19.1235 5.65853C19.2343 5.65853 19.3437 5.66359 19.4526 5.6709C19.0917 4.25507 18.3297 2.97518 17.2593 1.98677C16.1889 0.998355 14.8562 0.343969 13.4231 0.103133C11.9899 -0.137703 10.5181 0.0453802 9.18647 0.630134C7.85483 1.21489 6.72069 2.17614 5.92188 3.39707C5.94754 3.39674 5.97282 3.39512 5.99854 3.39512C7.11203 3.3936 8.20375 3.70535 9.15038 4.29514Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15207 4.29422L9.15184 4.29505C8.20521 3.70525 7.11349 3.39351 6 3.39503C5.97427 3.39503 5.94896 3.39665 5.92333 3.39697C4.8335 3.41054 3.76796 3.7226 2.84119 4.29962C1.91443 4.87663 1.16149 5.69678 0.663278 6.67193C0.165069 7.64708 -0.0595727 8.74037 0.0134948 9.83431C0.0865624 10.9283 0.454576 11.9815 1.07799 12.8808L5.52099 11L7.49605 10.1639L11.8937 8.30226L14.1903 7.33005L9.15207 4.29422Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4552 5.67106C19.3463 5.66375 19.2368 5.65869 19.1261 5.65869C18.4615 5.65804 17.8038 5.7946 17.1937 6.05991L14.1914 7.33031L15.062 7.85488L17.9157 9.5744L19.1607 10.3246L23.418 12.8899C23.8048 12.1675 24.0053 11.359 24.001 10.5385C23.9968 9.71794 23.7879 8.9116 23.3936 8.19331C22.9993 7.47502 22.4321 6.86773 21.7441 6.42708C21.056 5.98642 20.269 5.72647 19.4552 5.67106Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1598 10.3244L17.9147 9.57416L15.061 7.85465L14.1904 7.33008L11.8938 8.30227L7.49619 10.1639L5.52112 11L1.07812 12.8808C1.63025 13.6794 2.36629 14.3316 3.22339 14.7819C4.08049 15.2322 5.03319 15.4671 6.00013 15.4666H19.1251C20.0051 15.4669 20.8688 15.2274 21.6245 14.7737C22.3801 14.32 22.9995 13.6689 23.417 12.8896L19.1598 10.3244Z",
    fill: "#28A8EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6854_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 15.4667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneDrive);
export default __webpack_public_path__ + "static/media/one-drive.480ae763154ce4a4a49631f09cec2be9.svg";
export { ForwardRef as ReactComponent };